export default "__VITE_ASSET__DbcL7frw__"